// extracted by mini-css-extract-plugin
export default {"emptyLessonsBlock":"MyLessonsEmpty_emptyLessonsBlock__N3Ksh","text":"MyLessonsEmpty_text__sSz7H","emptyLessonsImg":"MyLessonsEmpty_emptyLessonsImg__FpTis"};